<template>
  <div v-if="dataLoaded">
    <loading v-bind:active.sync="loading"></loading>
    <div class="container-fluid">
      <div class="row">
        <div class="col-4 offset-1">
          <doughnut-chart v-if="dataLoaded" v-bind:chartdata="chartData" v-bind:options="chartOptions"></doughnut-chart>
          <div class="donut-center">
            <h6 class="total-header">Total</h6>
            <p class="total-value">${{ priceTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</p>
          </div>
        </div>
        <div class="col-6 offset-1 parent-block">
          <div class="child-block">
            <div class="row" v-for="index in rowsPerTwo" v-bind:key="index">
              <div class="col-6">
                <div class="display-box" v-bind:style="{ 'background-color': colors[index*2-2] }">
                  <p class="category-amount">{{ '$' + categoryPrices[index*2-2][1].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                  <h6 class="category-title">{{ categoryPrices[index*2-2][0] }}</h6>
                </div>
              </div>
              <div v-if="index*2-1 < categoryPrices.length" class="col-6">
                <div class="display-box" v-bind:style="{ 'background-color': colors[index*2-1] }">
                  <p class="category-amount">{{ '$' + categoryPrices[index*2-1][1].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                  <h6 class="category-title">{{ categoryPrices[index*2-1][0] }}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col">
        <p class="no-margin">No {{ diyFilter ? 'DIY' : 'contractor' }} HomFAX have been added yet. Please add a maintenance or improvement receipt to see your savings.</p>
      </div>
    </div>
    <div class="row button-padding">
      <div class="col-4 offset-4">
        <button class="btn btn-primary" v-on:click="addHomfax()">Add HomFAX</button>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DoughnutChart from './DoughnutChart.js'

export default {
  components: {
    Loading,
    DoughnutChart
  },
  data () {
    return {
      chartData: null,
      chartOptions: {
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return '$' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
          }
        },
        plugins: {
          datalabels: {
            color: 'white',
            font: {
              size: 16
            },
            formatter: (value, ctx) => {
              let percentage = (value * 100 / this.priceTotal).toFixed(2) + '%'
              return percentage
            }
          }
        },
        legend: {
          display: false
        },
        responsive: true
      },
      colors: [], // ['aquamarine', 'darkgoldenrod', 'blueviolet', 'crimson', 'aqua', 'deeppink', 'darkslateblue', 'brown', 'lavender', 'lightcyan', 'tomato', 'mediumseagreen', 'palegreen', 'silver', 'steelblue', 'mistyrose', 'turqoise', 'moccasin'],
      dataLoaded: false,
      homfaxStats: null,
      countTotal: 0,
      priceTotal: 0,
      loading: false
    }
  },
  props: {
    uniqueId: String,
    diyFilter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rowsPerTwo () {
      return Math.ceil(this.categoryPrices.length / 2)
    },
    categoryPrices () {
      if (this.homfaxStats && this.homfaxStats['prices']) {
        return Object.entries(this.homfaxStats['prices'])
      }
      return []
    }
  },
  methods: {
    addHomfax () {
      this.$emit('showHomfaxModal')
    },
    formatDate (timestamp) {
      let dateComponents = timestamp.split(/\D/)
      return dateComponents[1] + '/' + dateComponents[2] + '/' + dateComponents[0]
    },
    async getHomfaxStatistics () {
      this.loading = true
      try {
        var client = this.$store.getters.getHomFaxApigClientFactory
        var body = {}
        var params = {'property_id': this.uniqueId}
        var pathTemplate = '/homfax_stats/{property_id}'
        var method = 'GET'
        var additionalParams = {}
        if (this.diyFilter) {
          additionalParams = {
            queryParams: {
              filter: 'diy'
            }
          }
        }
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        if (result.status === 200) {
          this.homfaxStats = result.data
          this.priceTotal = this.homfaxStats['prices']['Total'].toFixed(2)
          delete this.homfaxStats['prices']['Total']
          var labels = []
          var dataSets = [{
            label: 'HomFAX Category Counts',
            data: [],
            backgroundColor: []
          }]
          var keys = Object.keys(this.homfaxStats['prices'])
          if (!keys.length) {
            this.loading = false
            return
          }
          this.colors = this.homfaxStats['colors']
          var i
          for (i = 0; i < keys.length; i++) {
            labels.push(keys[i])
            dataSets[0]['data'].push(this.homfaxStats['prices'][keys[i]])
            dataSets[0]['backgroundColor'].push(this.colors[i])
          }
          this.chartData = {
            labels: labels,
            datasets: dataSets
          }
          this.dataLoaded = true
        } else {
          console.log('Could not retrieve HomFAX stats.')
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    }
  },
  async mounted () {
    this.getHomfaxStatistics()
  }
}
</script>

<style scoped>
.category-amount {
  color: white !important;
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0;
}

.category-title {
  color: white !important;
  font-weight: normal;
}

.display-box {
  background-color: blue;
  border-style: solid;
  border-radius: 0.5rem;
  border-width: thin;
  margin-bottom: 0.5rem;
  text-align: center;
}

.button-padding{
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
}

.child-block {
  width: 100%;
}

.no-margin {
  margin: 0;
}

.parent-block {
  display: flex;
  justify-content: center;
  align-items: center;
}

.donut-center {
  margin-top: -60%;
  margin-bottom: 60%;
  text-align: center;
}

.total-header {
  font-size: 1.2rem;
  margin-bottom: 1%;
  margin-top: 0;
}

.total-value {
  font-size: 1.2rem;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .total-header {
    font-size: 1rem;
    margin-bottom: 1%;
    margin-top: 0;
  }

  .total-value {
    font-size: 1rem;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/dropdowns/HomFAXStatistics.vue